import React from 'react';
import '../CSS/Timetable.css'
import LeftArrow from '../Images/leftArrow.png';
import Left from '../Images/left.png';
import Right from '../Images/right.png';
import Refresh from '../Images/refresh.png';
import {useHistory} from 'react-router-dom';
import Loading from '../Components/Loading';
import Flatlist from 'flatlist-react';
import Model from '../Components/Timetable/Model';
import NoEvent from '../Components/Timetable/NoEvents';
import { motion} from 'framer-motion';
import { pageTransition, pageStyle, pageVariants } from '../Components/Animations/Transition';
import {convertDate, getDay} from '../Functions.js';
import {getUrl} from '../Functions.js';

function Timetable(props) {
  const history  = useHistory();
  if(localStorage.getItem("loggedIn")!=="true"){
    history.push("/opening");
  }
  const cookie = localStorage.getItem("cookie");
  var days = ["Funday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const [loading, setLoading] = React.useState(true);
  const [timetable, setTimetable] = React.useState([]);
  const [currentDay, setCurrentDay] = React.useState(getDay(0));
  const [currentDate, setCurrentDate] = React.useState(0);
  const [dateToday, setDateToday] = React.useState(convertDate(currentDate));
  
  var update = false;
  var loadingHeight="78vh";
  
  const options = {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      cookies:cookie,
      date:dateToday
    })
  }
  function back(){
    history.push("/home");
  }

  function fetchData(){
    if(localStorage.getItem("loggedIn")!=="true"){
      history.push("/opening");
    }
    setLoading(true);
    setTimetable([]);
    fetch(getUrl()+'timetable', options)
      .then(response => response.json()).then(
        data =>{
          if(data.retry===true){
            console.log("retrying...");
            fetchData();
          }else{
            setTimetable(data.timetable);
            setLoading(false);
            update = false;
          }
        }
      );
  }
  
  React.useEffect(() => {
    fetchData();
  },[dateToday]);

  return (
    <motion.div className="Timetable"
    initial={pageVariants.initial}
    animate="in"
    exit="out"
    style={pageStyle}
    variants={pageVariants}
    transition={pageTransition}>
      <div className="TopTimetable">
          <img src={LeftArrow} alt="back" className="BackTimetable" onClick={()=>{
            back();
          }} color="#000000" />
          <div ></div>
          <img src={Refresh} alt="refresh" className="RefreshTimetable" onClick={()=>{
            if(update!==true){
              update = true;
              fetchData();
            }}} color="#000000"/>
        </div>    

        <div >
        <div className="DateSelectorTimetable">
          <img src={Left} alt="left" className="DateArrowsTimetable" onClick={()=>{
            if(loading!==true){
              setCurrentDay(getDay(currentDate-1));
              setDateToday(convertDate(currentDate-1));
              setCurrentDate(currentDate-1);
            }
          }} color="#000000" />
          <div className="DateTextTimetable">
            {dateToday}
          </div>
          <img src={Right} alt="right" className="DateArrowsTimetable" onClick={()=>{
            if(loading!==true){
              setCurrentDay(getDay(currentDate+1));
              setDateToday(convertDate(currentDate+1));
              setCurrentDate(currentDate+1);
            }
          }} color="#000000" />
          </div>
          <div className="DayTextTimetable">
            {currentDay}
          </div>
          {loading===true?<Loading height={loadingHeight} color="#ffffff"/>:""}
          <div className="FlatListTimetable">  
            <Flatlist
              list={timetable}
              renderItem={(item,index)=>
              item.start===undefined?<NoEvent/>:<Model item={item} index={index}/> 
              }
              renderWhenEmpty={() =><div></div>}
              renderOnScroll
              />
              
        </div>
        </div>
    </motion.div>
  );
}

export default Timetable;